//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    element: {
      type: Object,
      default: function _default() {}
    },
    value: {
      required: true
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    model: function model(newValue) {
      console.log("aqui-------------------", newValue);
      this.$emit("input", newValue);
    },
    value: function value(newValue) {
      //this.model = newValue.value?newValue.value:newValue
      console.log(newValue);
    }
  },
  data: function data() {
    return {
      model: this.value
    };
  },
  computed: {},
  created: function created() {},
  methods: {}
};